module.exports = __webpack_public_path__ + "img/icn_instagram.540bbe7f.svg";